<template>
  <div>
    <DetalhamentoCarrinhosProduto :produto="produto" @click.stop="dialog_ativo = !dialog_ativo" />

    <v-dialog v-model="dialog_ativo" fullscreen transition="dialog-bottom-transition" persistent>
      <v-card>
        <v-card-title class="titulo">
          <v-btn dark icon @click.stop="dialog_ativo = !dialog_ativo" class="mr-5 ml-n2">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <span>Compra por filial</span>

          <ConsiderarEstoqueGrupo v-model="considerar_estoque_grupo" class="ml-10" dark usar_model_personalizada />

          <ConverterEmbalagem class="ml-10" dark />
        </v-card-title>

        <v-card-text class="pa-0">
          <v-data-table
            v-model="produtos_selecionados"
            height="calc(100vh - 160px)"
            :headers="CABECALHOS_COMPUTED"
            :items="ITEMS_FILTRADOS"
            class="table-full-screen mt-1"
            :item-class="itemClass"
            hide-default-footer
            fixed-header
            :items-per-page="-1"
            item-key="index"
            show-select
          >
            <template #top>
              <div class="px-4 py-3 d-flex align-center">
                <span class="font-17">Lista de produtos</span>
                <span
                  v-if="ANALISE_GRUPO_FORNECEDORES && produto.razao_social.length"
                  class="ml-8" v-html="`Fornecedor: ${produto.idfornecedor} - ${produto.razao_social}`"
                />

                <div v-show="produtos_selecionados.length" class="mt-n2">
                  <v-btn color="#042333" small dark class="ml-8" @click="adicionarNoCarrinho(produtos_selecionados)">
                    <v-icon left small>mdi-cart</v-icon>
                    <span>Adicionar</span>
                    <span class="qtde-top-button-small">{{ produtos_selecionados.length }}</span>
                  </v-btn>

                  <ConsolidarCompraParaUmaFilial
                    :produtos_selecionados="produtos_selecionados"
                    classes_css="ml-8"
                    @consolidacao:filial-selecionada="consolidarCompraParaUmaFilial"
                  />
                </div>
              </div>
            </template>

            <template #header.data-table-select>
              <v-icon v-if="!PRODUTOS_VALIDOS_PARA_SELECAO.length" class="ml-6px" disabled>mdi-checkbox-blank-outline</v-icon>
              <v-btn v-else icon @click="selecaoGeral()">
                <v-icon v-if="!produtos_selecionados.length">mdi-checkbox-blank-outline</v-icon>
                <v-icon v-else-if="produtos_selecionados.length === PRODUTOS_VALIDOS_PARA_SELECAO.length" color="primary">mdi-checkbox-marked</v-icon>
                <v-icon v-else color="primary">mdi-minus-box</v-icon>
              </v-btn>
            </template>

            <template #header.sugestao_transferencia="{header}">
              <v-tooltip bottom dark>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{ header.text }}</span>
                </template>
                <p class="ma-0 mb-1">É a quantidade do saldo de estoque disponível em outras filiais, para a filial da linha.</p>
              </v-tooltip>
            </template>

            <template #item.data-table-select="{item}">
              <v-icon v-if="!item.item_filial" class="ml-6px" disabled>$HomeSwitchOutline</v-icon>
              <v-icon v-else-if="!item.item_filial || item.edicao_bloqueada" class="ml-6px" disabled>mdi-checkbox-blank-outline</v-icon>
              <v-btn v-else icon @click="selecaoItem(item)">
                <v-icon v-if="produtos_selecionados.includes(item)" color="primary">mdi-checkbox-marked</v-icon>
                <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
              </v-btn>
            </template>

            <template #item.grupo="{item}">
              <div class="d-flex align-center w-75">
                <span class="w-full">{{ item.item_filial ? `Filial ${item.filial}` : 'Grupo' }}</span>
                <NivelServico :nivel_servico="item.nivel_servico" :label="`produto de ${item.nivel_servico}`.toLocaleLowerCase()" />
              </div>
            </template>

            <template #item.unidade_compra="{item}">
              {{ EMBALAGEM_MASTER_ATIVA ? item.unidade_master : item.unidade_compra }}
            </template>

            <template #item.dias_gatilho>
              <div class="text-center ml-n2">
                <span v-if="produto.tempo_gatilho > 0" style="color: green" v-text="`+ ${produto.tempo_gatilho} dias`" />
                <span v-else-if="produto.tempo_gatilho < 0" style="color: red" v-text="`- ${Math.abs(produto.tempo_gatilho)} dias`" />
                <span v-else v-text="produto.tempo_gatilho" />
              </div>
            </template>

            <template #item.estoque="{item}">
              {{ formatarNumero(item.estoque) }}
            </template>

            <template #item.sugestao_transferencia="{item}">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" style="cursor: help;">{{ item.item_filial ? formatarNumero(item.sugestao_transferencia) : `` }}</span>
                </template>
                <span>
                  <v-list-item
                    v-for="(qtde, filial) in formatarDadosDasFiliaisDoSaldoDeTransferencia(item.filiais_transferencia)"
                    :key="filial"
                    dark
                    dense
                  >
                    <v-list-item-content>
                      <v-list-item-title>Filial: {{ filial }} - Qtde: {{ qtde }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </span>
              </v-tooltip>

              <!-- <SugestaoDistribuicao
                v-if="item.sugestao_transferencia > 0"
                :filial_origem="item"
                :itens="produto_por_filial"
                :consumo_medio_total="CONSUMO_MEDIO_TOTAL"
              /> -->
            </template>

            <template #item.descricao_produto="{item}">
              <div class="d-flex align-center">
                <DetalhesProduto
                  v-if="!produto.produto_eh_combinacao"
                  :produto="{id_produto: item.idproduto, id_grupo: item.id_grupo, id_filial: item.filial || 9999}"
                  habilitar_edicao_parametros
                  @update:lote-minimo="buscarProdutoPorFilial()"
                  @update:tempo-ressuprimento="buscarProdutoPorFilial()"
                />
                <span v-text="item.descricao_produto" />
              </div>
            </template>

            <template #item.estoque_minimo="{ value }">{{ formatarNumero(value) }}</template>

            <template #item.estoque_maximo="{item, value}">
              <template v-if="item.item_filial">{{ formatarNumero(value) }}</template>
              <template v-else>{{ formatarNumero(SOMA_ESTOQUE_MAXIMO) }}</template>
            </template>

            <template #item.ponto_pedido="{item, value}">
              <template v-if="item.item_filial">{{ formatarNumero(value) }}</template>
              <template v-else>{{ formatarNumero(SOMA_PONTO_PEDIDO) }}</template>
            </template>

            <template #item.estoque_seguranca="{item, value}">
              <template v-if="item.item_filial">{{ formatarNumero(value) }}</template>
              <template v-else>{{ formatarNumero(SOMA_ESTOQUE_SEGURANCA) }}</template>
            </template>

            <template #item.consumo_medio_mensal_auxiliar="{item}">
              <template v-if="item.item_filial">{{ formatarNumero(item.consumo_medio_mensal_auxiliar) }}</template>
              <template v-else>{{ formatarNumero(CONSUMO_MEDIO_TOTAL) }}</template>
            </template>

            <template #item.cobertura_estoque_futura="{item}">
              <CalculaCoberturaEstoqueFutura :item="{...item, sugestao: (item.no_carrinho && item.edicao_bloqueada) ? item.qtd_no_carrinho : item.sugestao}" />
            </template>

            <template #item.preco_custo="{item}">
              <PrecoCusto v-model="preco_custo" @add-produto-carrinho="item.item_filial && adicionarNoCarrinho(item)" />
            </template>

            <template #item.sugestao="{item}">
              <InfoProdutoNoCarrinho v-if="item.no_carrinho && item.edicao_bloqueada" :item="item" />

              <ProdutoSilenciado v-else-if="item.silenciado && item.edicao_bloqueada" :item="item" />

              <SugestaoDeCompra
                v-else
                :ref="`inputSugestaoRef${item.item_filial ? `Filial${item.filial}` : 'Grupo'}`"
                :item="item"
                :produto_grupo="produto"
                :card_completar_compra="card_completar_compra"
                @add-produto-carrinho="adicionarNoCarrinho"
                @update:model-value="!item.item_filial && distribuirSugestaoProdutosPorFilial()"
              />
            </template>

            <template #item.total="{item}">
              <template v-if="item.item_filial">{{ Helpers.formatarValorMonetario(Number(preco_custo || 0) * Number(item.sugestao || 0)) }}</template>
              <template v-else>{{ Helpers.formatarValorMonetario(VALOR_TOTAL) }}</template>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="px-6">
          <v-spacer />
          <v-switch v-model="ocultar_produtos_carrinho" hide-details dense color="#A51B32">
            <template #label>
              <span class="ml-1 font-12">Ocultar produtos adicionados no carrinho</span>
            </template>
          </v-switch>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {buscarProdutoCompraDistribuidoPorFilial} from "@/api/compra";
import {logout, formatarValor, iniciarRequisicao} from "@/helpers";
import {converterEmbalagemItens, converterEmbalagemValor, converterValorParaEmbalagemMinima} from "./ConversaoEmbalagem";
import {verificarMultiploLoteMinimo} from "./VerificaMuliploLoteMinimo.js";
import {componentes} from "./Componentes";
import {cabecalhos} from "./Cabecalhos";
import CarrinhoAPI from "@/api/carrinho";
import {mapGetters} from "vuex";
import {info_pedido_geral} from "@/components/compra/ProdutosGerais/InfoPedidoGeral";

export default {
  name: "DistribuirCompraPorFilial",
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  components: componentes,
  props: {
    produto: Object,
    card_completar_compra: Boolean,
    modelValue: Boolean,
    analiseGrupoFornecedores: {
      type: String,
      default: () => localStorage.analiseGrupoFornecedores
    }
  },
  data: () => ({
    dialog_ativo: false,
    produtos_selecionados: [],
    produto_por_filial: [],
    cabecalhos,
    considerar_estoque_grupo: localStorage.config_multifilial_considerar_estoque_grupo === 'S',
    sugestao_total_inicial: null,
    ocultar_produtos_carrinho: null,
    preco_custo: 0,
    preco_custo_base: 0,
  }),
  computed: {
    CABECALHOS_COMPUTED() {
      if (localStorage.preco_compra_grupo === 'N') {
        return this.cabecalhos.filter(item => !["preco_custo", "total"].includes(item.value));
      }
      return this.cabecalhos;
    },
    ...mapGetters({
      EMBALAGEM_MASTER_ATIVA: "EmbalagemTelaDeCompras/getEmbalagemMaster",
      FILTROS_STORE: "CompraProdutosGerais/getFiltros",
    }),
    ITEMS_GRID() {
      if (!this.produto_por_filial.length || this.produto_por_filial.length === 0) {
        return [this.produto];
      }
      return [this.produto].concat(this.produto_por_filial);
    },
    ITEMS_FILTRADOS() {
      if (this.ocultar_produtos_carrinho) {
        const itens = this.ITEMS_GRID.filter(item => !item.no_carrinho);
        return itens.length > 1 ? itens : [];
      }
      return this.ITEMS_GRID;
    },
    SOMA_ESTOQUE_SEGURANCA() {
      const callback = (a, b) => a + Number(b.estoque_seguranca);
      return this.produto_por_filial.reduce(callback, 0);
    },
    SOMA_PONTO_PEDIDO() {
      const callback = (a, b) => a + Number(b.ponto_pedido);
      return this.produto_por_filial.reduce(callback, 0);
    },
    SOMA_ESTOQUE_MAXIMO() {
      const callback = (a, b) => a + Number(b.estoque_maximo);
      return this.produto_por_filial.reduce(callback, 0);
    },
    SOMA_CONSUMO_MEDIO_FILIAIS_UND_PADRAO() {
      const callback = (a, b) => a + Number(b.consumo_medio_mensal);
      return this.produto_por_filial.reduce(callback, 0);
    },
    CONSUMO_MEDIO_TOTAL() {
      const {tipo_fator_conversao, multiplo_compra} = this.produto;
      return converterEmbalagemValor(this.SOMA_CONSUMO_MEDIO_FILIAIS_UND_PADRAO, this.EMBALAGEM_MASTER_ATIVA, tipo_fator_conversao, multiplo_compra);
    },
    SUGESTAO_TRANSFERENCIA_TOTAL_GERAL() {
      return this.produto_por_filial.reduce((a,  b) => a + Number(b.sugestao_transferencia), 0);
    },
    SUGESTAO_TOTAL_FILIAIS() {
      const callback = (a, b) => (a + Number(b.sugestao))
      return this.produto_por_filial.reduce(callback, 0);
    },
    PRODUTOS_VALIDOS_PARA_SELECAO () {
      const callback = item => !item.edicao_bloqueada
        && `${this.produto.filial}-${this.produto.idproduto}` !== `${item.filial}-${item.idproduto}`
        && !item.silenciado;
      return this.produto_por_filial.filter(callback);
    },
    SUGESTAO_TOTAL_INICIAL_EMBALAGEM () {
      const {tipo_fator_conversao, multiplo_compra} = this.produto;
      return converterEmbalagemValor(this.sugestao_total_inicial, this.EMBALAGEM_MASTER_ATIVA, tipo_fator_conversao, multiplo_compra);
    },
    ANALISE_GRUPO_FORNECEDORES() {
      return this.analiseGrupoFornecedores === 'S';
    },
    QTDE_PRODUTOS_NO_CARRINHO() {
      const callback = (a, b) => b.no_carrinho ? a + 1 : a;
      return this.produto_por_filial.reduce(callback, 0)
    },
    VALOR_TOTAL() {
      return this.produto_por_filial.reduce((a, b) => a + (Number(this.preco_custo || 0) * Number(b.sugestao || 0)), 0)
    },
    ESTA_NA_TELA_COMPRA_POR_FORNECEDOR() {
      return this.$route.path === '/compra';
    }
  },
  watch: {
    dialog_ativo() {
      if (this.dialog_ativo) {
        this.considerar_estoque_grupo = this.$store.getters["CompraDistribuidaPorFilial/get_considerar_estoque_grupo"];
        this.buscarProdutoPorFilial();
        this.ocultar_produtos_carrinho = this.modelValue;
      } else {
        this.$emit('atualizar-listagem-produtos', {qtd_pedidos_filial_com_produto: this.QTDE_PRODUTOS_NO_CARRINHO});

        this.produto_por_filial = [];
        this.$store.dispatch('CompraDistribuidaPorFilial/set_considerar_estoque_grupo', this.considerar_estoque_grupo);

        localStorage.flag_multifiliais_ocultar_produto_carrinho = this.ocultar_produtos_carrinho ? 'S' : 'N';
        this.$emit('update:modelValue', this.ocultar_produtos_carrinho);
      }
    },
    'produto.sugestao': function () {
      if (this.$refs.inputSugestaoRefGrupo && this.$refs.inputSugestaoRefGrupo.focado) {
        this.distribuirSugestaoProdutosPorFilial();
      }
    },
    SUGESTAO_TOTAL_FILIAIS() {
      if (this.$refs.inputSugestaoRefGrupo && !this.$refs.inputSugestaoRefGrupo.focado) {
        this.produto.sugestao = this.SUGESTAO_TOTAL_FILIAIS;
      }
    },
    EMBALAGEM_MASTER_ATIVA() {
      this.converterEmbalagem();
    },
    considerar_estoque_grupo() {
      if (this.considerar_estoque_grupo && localStorage.ocultar_considerar_estoque_grupo_na_compra_por_filial !== 'S') {
        this.$refs.inputSugestaoRefGrupo && this.$refs.inputSugestaoRefGrupo.focus();
        this.produto.sugestao = this.SUGESTAO_TOTAL_INICIAL_EMBALAGEM;
        this.distribuirSugestaoProdutosPorFilial();
      } else {
        this.buscarProdutoPorFilial();
      }
    }
  },
  methods: {
    formatarDadosDasFiliaisDoSaldoDeTransferencia(d) {
      if (d == undefined) {
        return null;
      }
      return JSON.parse(d);
    },
    formatarNumero: formatarValor,
    buscarProdutoPorFilial() {
      const parametros = {
        id_grupo: this.produto.id_grupo,
        idproduto: this.produto.idproduto,
        idfornecedor: this.produto.idfornecedor,
        considerar_estoque_grupo: this.considerar_estoque_grupo && localStorage.ocultar_considerar_estoque_grupo_na_compra_por_filial !== 'S' ? 'S' : 'N',
        card_completar_compra: this.card_completar_compra ? 'S' : 'N',
        produto_eh_combinacao: this.produto.produto_eh_combinacao ? 'S' : 'N',
        idsegmento: (this.FILTROS_STORE.segmentos.length > 0) ? this.produto.idsegmento : 0,
        idsecao: (this.FILTROS_STORE.secoes.length > 0) ? this.produto.idsecao : 0,
      };

      this.$store.dispatch('loading/addRequisicao',
        buscarProdutoCompraDistribuidoPorFilial(parametros)
          .then(({produtos, sugestao_grupo, preco_custo_grupo}) => {
            this.sugestao_total_inicial = sugestao_grupo;

            const callback = (item, index) => {
              item.index = `__${index}`;
              item.sugestao_fixa = item.sugestao;
              item.tipo = this.produto.tipo;
              item.edicao_bloqueada = item.no_carrinho !== false ||  item.silenciado === true;
              item.item_filial = true;
              item.consumo_medio_mensal_auxiliar = item.consumo_medio_mensal;
              return item;
            };

            this.produto_por_filial = produtos.map(callback);

            if (this.considerar_estoque_grupo) {
              this.distribuirSugestaoProdutosPorFilial();
            }

            this.adicionarSugestaoFixa();

            if (this.EMBALAGEM_MASTER_ATIVA) {
              this.converterEmbalagem();
            }

            this.preco_custo = Number(preco_custo_grupo);
            this.preco_custo_base = this.preco_custo;
          })
          .catch(logout)
      );
    },
    adicionarSugestaoFixa() {
      const callback = item => item.sugestao_fixa = item.sugestao;
      this.produto_por_filial.map(callback);
    },
    distribuirSugestaoProdutosPorFilial() {
      const sugestao_total_grupo = Number(this.produto.sugestao || 0);

      const dividirSugestaoCallback = item => {
        const sugestao_bruta = Math.max((Number(item.consumo_medio_mensal_auxiliar) / this.CONSUMO_MEDIO_TOTAL) * sugestao_total_grupo, 0);
        item.sugestao = ((sugestao_bruta % item.lote_minimo) * -1) + sugestao_bruta;
      };

      this.produto_por_filial.forEach(dividirSugestaoCallback);

      const buscarFilialParaComprarResto = (a, b) => Number(a.consumo_medio_mensal_auxiliar) > Number(b.consumo_medio_mensal_auxiliar) ? a : b;
      const filial_para_compra_resto = this.produto_por_filial.reduce(buscarFilialParaComprarResto);

      filial_para_compra_resto.sugestao += Math.max(sugestao_total_grupo - this.SUGESTAO_TOTAL_FILIAIS, 0);
    },
    itemClass(item) {
      return {
        'sys-data-table-blue-linha-ativa': !item.item_filial,
        'text-gray-100': item.edicao_bloqueada
      }
    },
    adicionarNoCarrinho(itens) {
      const produtos = Array.isArray(itens) ? itens : [itens];
      const produtos_formato = [];

      for (const produto of produtos) {
        if (Number(produto.sugestao) <= 0) {
          continue;
        }

        if (!produto.comprar_fora_lote_minimo && !verificarMultiploLoteMinimo(produto.sugestao, produto.lote_minimo)) {
          continue;
        }

        const qtd_compra = this.EMBALAGEM_MASTER_ATIVA
          ? converterValorParaEmbalagemMinima(produto.sugestao, produto.tipo_fator_conversao, produto.multiplo_compra)
          : produto.sugestao;

        const produto_formato = {
          fornecedor: this.ESTA_NA_TELA_COMPRA_POR_FORNECEDOR ? this.produto.idfornecedor : info_pedido_geral.idfornecedor,
          produto: produto.idproduto,
          qtde: qtd_compra,
          sugestao: produto.sugestao_fixa,
          grupo: produto.id_grupo,
          filial: produto.filial,
          tipo_compra: produto.tipo,
          motivos: [],
          analiseGrupoFornecedores: this.analiseGrupoFornecedores,
          produto_eh_combinacao: produto.produto_eh_combinacao,
          idsegmento: (this.FILTROS_STORE.segmentos.length > 0) ? this.produto.idsegmento : 0,
          idsecao: (this.FILTROS_STORE.secoes.length > 0) ? this.produto.idsecao : 0,
        };

        if (localStorage.preco_compra_grupo === 'S') {
          produto_formato.preco_custo = this.preco_custo;
          produto_formato.preco_custo_base = this.preco_custo_base;
        }

        produtos_formato.push(produto_formato);
      }

      if (produtos_formato.length === 0) {
        alert('Verifique se a quantidade de compra está de acordo com o lote mínimo.')
        this.produtos_selecionados = [];
        return;
      }

      this.$store.dispatch('loading/addRequisicao',
        CarrinhoAPI.addMultCarrinhoGrupo(iniciarRequisicao(), produtos_formato)
          .then(response => {
            const {token} = response.data;
            localStorage.token = token;
            this.removerProdutosAdicionadosCarrinho(produtos_formato);
            this.produtos_selecionados = [];
          })
          .catch(logout)
      );
    },
    consolidarCompraParaUmaFilial({ filial }) {
      const total_sugestao = this.produtos_selecionados.reduce((a, b) => a + Number(b.sugestao || 0), 0);

      this.produtos_selecionados.forEach(item => {
        item.sugestao = 0;
      });

      const filial_selecionada = this.produto_por_filial.find(item => Number(item.filial) === Number(filial));
      filial_selecionada.sugestao += total_sugestao;

      this.adicionarNoCarrinho([filial_selecionada]);
      this.produtos_selecionados = [];
    },
    removerProdutosAdicionadosCarrinho(produtos) {
      const callback = item => {
        const no_carrinho = !item.edicao_bloqueada
          && produtos.some(prod => `${prod.filial}-${prod.produto}` === `${item.filial}-${item.idproduto}`);

        if (no_carrinho) {
          item.no_carrinho = true;
          item.edicao_bloqueada = true;
          item.qtd_no_carrinho = item.sugestao;
        }

        return item;
      };
      this.produto_por_filial = this.produto_por_filial.map(callback);
    },
    converterEmbalagem() {
      this.produto_por_filial = converterEmbalagemItens(this.produto_por_filial, this.EMBALAGEM_MASTER_ATIVA);
    },
    selecaoItem(produto) {
      if (this.produtos_selecionados.includes(produto)) {
        this.produtos_selecionados = this.produtos_selecionados.filter(item => item !== produto);
      } else {
        this.produtos_selecionados.push(produto);
      }
    },
    selecaoGeral() {
      if (this.produtos_selecionados.length === this.PRODUTOS_VALIDOS_PARA_SELECAO.length) {
        this.produtos_selecionados = [];
        return;
      }
      this.produtos_selecionados = this.PRODUTOS_VALIDOS_PARA_SELECAO;
    }
  }
}
</script>

<style scoped>
.ml-6px {
  margin-left: 6px;
}
.titulo {
  background-color: #042333;
  color: white;
}
</style>
